import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./i18n";
import "./utilities/cssViewportHeight";
import "./utilities/cssHeaderHeight";
import "./index.css";

const container = document.getElementById("puregym_approot");
const root = ReactDOM.createRoot(container);
root.render(<App {...container.dataset} />);
